"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorLatestImportReport = void 0;
const routes_1 = require("../../routes");
const getDistributorLatestImportReport = (client) => async (params) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_DISTRIBUTOR_LATEST_IMPORT_REPORT.applyParams(params));
    return response.data;
};
exports.getDistributorLatestImportReport = getDistributorLatestImportReport;
